import { i18n } from '@hefe/i18n';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import weekday from 'dayjs/plugin/weekday';

dayjs.extend(relativeTime);
dayjs.extend(weekday);

export function greeting(): string {
  const currentHour = dayjs().hour();

  let greeting = 'hello';

  if (currentHour > 4 && currentHour < 12) {
    greeting = 'good_morning';
  } else if (currentHour > 11 && currentHour < 18) {
    greeting = 'good_day';
  } else if (currentHour > 17 && currentHour < 23) {
    greeting = 'good_evening';
  }

  return 'greetings.' + greeting;
}

export function dateFormat(options?: { withoutYear?: boolean }): string {
  const currentLang = i18n.default.language;
  let format = 'YYYY-MM-DD';

  if (currentLang === 'de' || currentLang.startsWith('de-')) {
    format = 'DD.MM.YYYY';
  }

  if (options?.withoutYear) {
    format = format.replace(/YYYY/g, '');
    if (format.startsWith('-')) {
      // Only replace first -
      format = format.replace(/^-/, '');
    }
  }

  return format;
}

export function dayMonthTextFormat(): string {
  const currentLang = i18n.default.language;
  let format = 'MMM DD';

  if (currentLang === 'de' || currentLang.startsWith('de-')) {
    format = 'DD. MMM';
  }

  return format;
}

export function timeFormat(): string {
  return 'HH:mm';
}

export function formatDate(
  date: string,
  withWeekday?: 'short' | 'long',
  withoutYear?: boolean
): string {
  const weekday = withWeekday
    ? withWeekday === 'short'
      ? 'ddd '
      : 'dddd '
    : '';
  return dayjs(date).format(weekday + dateFormat({ withoutYear }));
}

export function formatDatabaseDate(
  date: string | number | dayjs.Dayjs | Date | null | undefined,
  withTime?: boolean
): string {
  const dateString = 'YYYY-MM-DD' + (withTime ? ' HH:mm:ss' : '');
  return dayjs(date).format(dateString);
}

interface FormatTimeOptions {
  /** Input is only a time string (eg. 12:00:00) */
  timeInput?: boolean;
}

export function formatTime(
  date: string | number | dayjs.Dayjs | Date | null | undefined,
  options?: FormatTimeOptions
): string {
  let fullDate = date;
  if (options?.timeInput) {
    fullDate = `${dayjs().format('YYYY-MM-DD')} ${date}`;
  }
  return dayjs(fullDate).format(timeFormat());
}

interface FormatDateTimeOptions {
  withHypens?: boolean;
  withWeekday?: 'short' | 'long';
  withoutYear?: boolean;
}

export function formatDateTime(
  date: string,
  options?: FormatDateTimeOptions
): string {
  return (
    formatDate(date, options?.withWeekday, options?.withoutYear) +
    (options?.withHypens ? ' - ' : ' ') +
    formatTime(date)
  );
}

export function formatTimeAgo(date: string) {
  return dayjs(date).fromNow();
}

export function currentSeasonStartDate(): dayjs.Dayjs {
  const currentYear = dayjs().year();
  const currentMonth = dayjs().month();
  let seasonStartYear = currentYear;
  if (currentMonth < 7) {
    seasonStartYear--;
  }
  return dayjs(`${seasonStartYear}-08-01`);
}

export function currentSeasonEndDate(): dayjs.Dayjs {
  const currentYear = dayjs().year();
  const currentMonth = dayjs().month();
  let seasonStartYear = currentYear;
  if (currentMonth < 7) {
    seasonStartYear--;
  }
  return dayjs(`${seasonStartYear + 1}-07-31`);
}

export function formatWeekday(date: string | number): string {
  // if string -> dajys(date) -> name of weekday as text (eg. 'Monday')
  // if number -> daysjs().weekday(number) -> name of weekday as text (eg. 'Monday')

  if (typeof date === 'string') {
    return dayjs(date).format('dddd');
  } else {
    return dayjs().weekday(date).format('dddd');
  }
}
